import React, { forwardRef } from 'react';
import styled from 'styled-components';

import Box from '@ui/box/Box.tsx';

import { useCSSColors } from '../../hooks/useCSSColors.ts';

const StyledImage = styled.img`
  min-height: 28px;
  max-height: 55px;
  width: auto;
  max-width: 100%;
`;

type LogoProps = React.ComponentPropsWithoutRef<typeof Box> & {
  alt: string;
  crossOrigin?: React.ImgHTMLAttributes<HTMLImageElement>['crossOrigin'];
  logoHeight?: string;
  position?: 'left' | 'center' | 'right';
  url: string;
};

const Logo = forwardRef<HTMLDivElement, LogoProps>((props, ref) => {
  const {
    url,
    alt,
    logoHeight,
    crossOrigin,
    position = 'center',
    'data-testid': dataTestId = 'Logo',
    ...omittedProps
  } = props;
  const colors = useCSSColors();

  const alignmentType = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  } as const;

  return (
    <Box
      ref={ref}
      data-testid={dataTestId}
      display="flex"
      bg={colors.widgetBackground}
      p="20px 20px 0 20px"
      justifyContent={alignmentType[position as keyof typeof alignmentType]}
      width="320px"
      {...omittedProps}
    >
      <StyledImage src={url} alt={alt} height={logoHeight} crossOrigin={crossOrigin} />
    </Box>
  );
});

Logo.displayName = 'Logo';

export default Logo;
